<template>
	<vxe-modal v-model="showFlag" title="选择客户信息" :destroy-on-close="true"
					remember :esc-closable="false" width="60%">
		<vxe-table  align="center" :data="list"  border height="500"  show-overflow="tooltip" size="mini" :loading="loading" @checkbox-change="selectChangeEvent"
						  resizable highlight-hover-row   :checkbox-config="{trigger: 'row', highlight: true, range: true}"  row-id="MID">
				<vxe-table-column type="checkbox" width="40"></vxe-table-column>
				<vxe-table-column title="用户号" field="customerNum"  sortable></vxe-table-column>
				<vxe-table-column title="支付宝缴费号" field="PID" ></vxe-table-column>
				<vxe-table-column title="给水号" field="APID"  ></vxe-table-column>
				<vxe-table-column title="用户名" field="CustomerName"></vxe-table-column>
				<vxe-table-column title="集中器" field="GPRSAddr"></vxe-table-column>
				<vxe-table-column title="采集器地址" field="CollectorAddr" ></vxe-table-column>
				<vxe-table-column title="表地址" field="MeterAddr"></vxe-table-column>
		</vxe-table>
	</vxe-modal>
</template>

<script>
	export default {
		data(){
			return {
				showFlag:false,
				list:[],
				loading:false,
			}
		},
		methods: {
			selectChangeEvent({ checked, records }) {
				if(records.length == 2){
					setTimeout(()=>{
						this.closeView();
						this.$emit('doCheckSelect',records);
					},300);
				}
			},
			showView(neighborId) {
				this.showFlag = true;
				this.queryListData(neighborId);
			},
			closeView(){
				this.showFlag = false;
			},
			queryListData:function(neighborId){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_LIST_URL);
				let param = {neighborId:neighborId,lihu:'0'};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
		},
		created(){
			
		},
	}
</script>

<style>
</style>
